// frontend/src/features/euanalyzer/pdf.js
import api from "../../apiClient";

/**
 * Create and download the EU flyer PDF for a given row.
 * Throws a user-friendly Error if something goes wrong.
 */
export async function createAndDownloadFlyer(row, idxRow, getDerived, taxRate) {
  const { stats, chosen } = getDerived(row, idxRow);
  if (!chosen || !chosen.length) {
    throw new Error("Select at least 1 comp to include.");
  }

  const taxRateDec = Number(taxRate || 0) / 100;
  const payload = {
    subject: row.subject,
    comps: chosen,
    stats: { ...stats, value_basis: "market_value", tax_rate: taxRateDec },
    auto_map: false,
    tax_rate: taxRateDec,
  };

  const fd = new FormData();
  fd.append("payload", JSON.stringify(payload));

  // Request PDF blob
  const res = await api.post("/eu/flyer", fd, { responseType: "blob" });

  // Download
  const blob = new Blob([res.data], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  const idSafe = row?.subject?.id || "subject";
  a.download = `E&U_${idSafe}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
